module.exports = __webpack_public_path__ + "static/media/blissdiet.bca0a981.png";